export function cleanObject(item, nullFn = val => val == null) {
  const values = Object.assign({}, item);
  Object.keys(values).forEach(key => {
    if (nullFn(values[key])) {
      delete values[key];
    }
  });
  return values;
}